import enMessages from '../../../_augmentt/i18n/messages/en.json'

// Polling runs outside React, and most screens render the message as is, so it is read from the English copy
export const TASK_STILL_PROCESSING_MESSAGE = enMessages['GENERAL.PROCESSING_IN_BACKGROUND']

export class TaskStillProcessingError extends Error {
  constructor() {
    super(TASK_STILL_PROCESSING_MESSAGE)
    this.name = 'TaskStillProcessingError'
  }
}

// Screens receive the message string rather than the error, so the timeout is recognised by its message
export const isTaskStillProcessing = (errorOrMessage) => {
  const message = typeof errorOrMessage === 'string' ? errorOrMessage : errorOrMessage?.message

  return message === TASK_STILL_PROCESSING_MESSAGE
}
